import { ApiResponseEntityBuilderInterface } from '@mkx/interfaces/common/api-response-entity-builder.interface';

export class InstanceLoaderService {
  static getInstance<T>(
    builder: ApiResponseEntityBuilderInterface,
    data: any
  ): T {
    return builder.buildFromAPIResponse(data);
  }
}
